import React from 'react';
import { Link } from 'react-router-dom';
import { KiteIcon } from '@kite/react-kite';
import { SortableTable } from '@kite/react-kite-plus';

import TableStatus from '../TableStatus/TableStatus';

import { ISeries } from '../../utils/models';
import { renderTableDate } from '../../utils/helpers';

import './SeriesTable.scss';

export interface ISeriesTableProps {
  seriesData: ISeries[];
  loading: boolean;
}

const SeriesTable = ({ seriesData, loading }: ISeriesTableProps) => {
  const columns = [
    {
      label: 'Title',
      sortKey: 'title',
    },
    {
      label: 'Added',
      sortKey: 'addedOn',
      render: ({ addedOn }) => renderTableDate(addedOn),
    },
    {
      label: 'Updated',
      sortKey: 'updatedOn',
      render: ({ updatedOn }) => renderTableDate(updatedOn),
    },
    {
      label: 'Series Status',
      sortKey: 'status',
      render: ({ status, errors }) => (
        <TableStatus status={status} errors={errors} />
      ),
      size: 0.5,
    },
    {
      label: '',
      sortKey: '',
      sortEnabled: false,
      render: (item) => (
        <Link to={`/series/${item.id}`} className="movies-table__link">
          View Series
          <KiteIcon name="chevron-right" color="#0073d1" />
        </Link>
      ),
      size: 0.5,
    },
  ];
  return (
    <SortableTable
      className="series-table"
      columns={columns}
      tableData={seriesData}
      initialSortHeader="number"
      loading={loading}
    />
  );
};

export default SeriesTable;
